export enum SubscriptionStatus {
	Active='active',
    Canceled='canceled',
    Incomplete='incomplete',
    IncompleteExpired='incomplete_expired',
    PastDue='past_due',
    Trialing='trialing',
    Unpaid='unpaid',
}